import { ParameterAward } from "src/app/modules/SimulationTool/types/parameter-setting";

export type ParameterFormState = {
  code: string;
  name: string;
  type: string;
  awards: ParameterAward[];
};

type SetFormStateAction = {
  type: 'SET_FORM_STATE';
  payload: {
    value: Partial<ParameterFormState>;
  };
};

type ModifyFieldAction = {
  type: 'MODIFY_FIELD';
  payload: {
    field: keyof ParameterFormState;
    value: any;
  };
};

type ParameterFormAction =
  | SetFormStateAction
  | ModifyFieldAction

export const parameterFormReducer = (state: ParameterFormState, action: ParameterFormAction): ParameterFormState => {
  switch (action.type) {
    case 'SET_FORM_STATE':
      return {
        ...state,
        ...action.payload.value,
      };
    case 'MODIFY_FIELD':
      return {
        ...state,
        [action.payload.field]: action.payload.value,
      };
    default:
      return state;
  }
};
